export default {"src":"/hub/_next/static/media/techtarget-logo.16c0027d.svg","height":44,"width":84,"blurWidth":0,"blurHeight":0};